<template>
  <section class="login">
    <div class="login_content" v-if="view_form">
      <div class="page_title">Reset password</div>
      <form action="" >
        <div class="title">Enter new password</div>
        <div class="inputs__wrapper">
          <div class="input__wrapper">
            <div class="text">New password</div>
            <InputPasswordValodation v-model:password="v$.valueField.password.$model"></InputPasswordValodation>
          </div>
          <div class="input__wrapper">
            <div class="text">Confirm password</div>
            <InputPassword v-model:password="v$.valueField.confirmPassword.$model" :class="{ 'error': v$.valueField.confirmPassword.$invalid && submitted }"></InputPassword>
          </div>
        </div>
        <button class="btn_login" type="submit" @click="ResetPass">Continue</button>
      </form>
    </div>
    <div class="error__content" v-else-if="view_form == false">
      <div>
        <div class="title__error">Time is up</div>
        <div class="text__error">Resend request</div>
      </div>
      <ButtonOrange @click="ReSend" style="width: 150px;">Resend</ButtonOrange>
    </div>
  </section>
  <StatusRequest ref="toast"></StatusRequest>
</template>
<script>
import axios from "axios";
import { useRoute } from 'vue-router'
import StatusRequest from "@/components/UI/StatusRequest.vue";
import InputPasswordValodation from "@/components/UserGroups/InputPasswordValodation.vue";
import InputPassword from "@/components/UserGroups/InputPassword.vue";
import { useVuelidate } from '@vuelidate/core'
import { required, minLength} from '@vuelidate/validators';
import ButtonOrange from "@/components/UI/ButtonOrange.vue";
export default {
  setup: () => ({ v$: useVuelidate() }),
  components: {
    StatusRequest,
    InputPasswordValodation,
    InputPassword,ButtonOrange
  },
  data() {
    return {
      view_form: null,
      email: '',
      token: '',
      submitted: false,
      valueField: {
          password: '',
          confirmPassword: '',
      },
    }
  },
  validations() {
      return {
          valueField: {
              password: { required, minLength: minLength(8) },
              confirmPassword: { required, sameAsPassword: this.sameAsPassword },
          }
      }
  },
  methods: {
    sameAsPassword() {
        return this.valueField.confirmPassword === this.valueField.password;
    },
    ResetPass(e){
      e.preventDefault();
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.valueField.$invalid) {
          this.request = false;
      } else {
        let fData = new FormData();
        fData.append("email", this.email);
        fData.append("token", this.token);
        fData.append("password",this.valueField.password);
        fData.append("password_confirmation",this.valueField.confirmPassword);
        axios.post("/reset-password",fData).then(resp => {
          if (resp.data['result'] == true) {
            this.showMessage(true,"Successful");
            setTimeout(() => {
              this.$router.push({name:"login"});
            },2000);
          }
          else if(resp.data.error) this.showMessage(false,"Failed");
          else {
            this.showMessage(false,"Произошла неизвесная ошибка, попробуйте позже");
          }
        }).catch(()=>{this.showMessage(false,"The password field confirmation does not match.")});
      }
    },
    getResetPassword(){
      const route = useRoute();
      this.email = route.query.email;
      this.token = route.query.token;
      this.type = route.query.type;
      let fData = new FormData();

      fData.append("email",route.query.email);
      fData.append("token",route.query.token);
      axios.post("/reset-password-init",fData).then(resp => {
        if (resp.data['result'] == true) {
            this.view_form = true;
        }
        else if(resp.data['result'] == false){
            this.view_form = false;
        }
      }).catch(()=>{

      });
    },
    ReSend(){
      setTimeout(() => {
        this.$router.push({name:"forgot-password"});
      },200);
    },
    showMessage(type, title) {
      if (type) type = 'success';
      else type = "error";
      const toast = this.$refs.toast;
      toast.show(type, title, 5000);
    }

  },
  mounted() {
    this.getResetPassword();
  },
}
</script>

<style scoped>
.error__content{
  position: relative;
  max-width: 450px;
  width: 450px;
  padding: 16px;
  padding-top: 24px;
  border-radius: 8px;
  border: 1.5px solid var(--gray-stroke, #E5E5EA);
  background: #FFF;

  /* 2 */
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06), 0px 0px 4px 0px rgba(0, 0, 0, 0.04);
}
.title__error{
  color: var(--red-200, #EA2313);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 120% */
  padding-bottom: 24px;
}
.text__error{
  color: var(--black-300, #333);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.32px;
  padding-bottom: 24px;
}

.form-check{
  max-width: 358px;
  width: 358px;
  padding: 16px;
  padding-top: 24px;
  border-radius: 8px;
  border: 1.5px solid var(--gray-stroke, #E5E5EA);
  background: #FFF;

  /* 2 */
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06), 0px 0px 4px 0px rgba(0, 0, 0, 0.04);
}

.title__check{
  color: var(--black-300, #333);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 120% */
  padding-bottom: 24px;
}
.text__check{
  color: var(--gray-400, #606060);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 133.333% */
  padding-bottom: 22px;
}
.checkbox{
  display: flex;
  gap: 8px;
  align-items: center;
}
.login {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login_content .page_title{
  color: var(--black-400, #292929);
  text-align: center;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.192px;
  padding-bottom: 40px;
}
.login_content form{
  padding: 16px;
  padding-top: 35px;
  width: 562px;
  border-radius: 8px;
  border: 1.5px solid var(--gray-stroke, #E5E5EA);
  background: #FFF;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06), 0px 0px 4px 0px rgba(0, 0, 0, 0.04);
}

.inputs__wrapper{
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;
}
.login_content .title {
  color: var(--black-300, #333);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 120% */
  padding-bottom: 16px;
}
.login_content .input__wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.input__wrapper .text {
  color: var(--black-400, #292929);
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 123.077% */
}
.input__wrapper input{
  border-radius: 8px;
  border: 1.5px solid var(--gray-stroke, #E5E5EA);
  height: 40px;
  padding-left: 12px;
}
.btn{

}
.login_content .btn_login{
  cursor: pointer;
  border-radius: 8px;
  border: 1.5px solid var(--gray-stroke, #E5E5EA);
  background: var(--white-100, #FFF);
  height: 44px;
  width: 100%;
  color: var(--black-300, #333);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.32px;
}
@media screen and (max-width: 768px) {
  .login_content form,
  .error__content,
  .form-check{
    width: calc(100% - 32px);
  }
}
</style>